import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import BoshSahifa from "./components/BoshSahifa/BoshSahifa";
import Header from "./components/Header/Header";
import ReadingListAll from "./components/BoshSahifa/ReadingListAll/ReadingListAll";
import Saqlangan from "./components/Saqlangan/Saqlangan";
import arr from "./Obj";
import NewStory from "./components/NewStory/NewStory";
import DescInside from "./components/BoshSahifa/Comment/DescInside/DescInside";
import RightFixed from "./components/RightFixed/RightFixed";
import MySaved from "./components/MySaved/MySaved";
import News from "./components/News/News";
import ListEach from "./components/Saqlangan/ListEach/ListEach";
import EachSaved from "./components/MySaved/EachSaved";

export default function Container(props) {
  let [mainArr, setMainArr] = useState(arr);
  let [saved, setSaved] = useState([]);
  let [savedToList, setSavedToList] = useState([]);
  let [ownSaved, setOwnSaved] = useState([]);

  let [newList, setNewList] = useState([]);

  const [inputVal, setInputVal] = useState("");
  useEffect(() => {
    setSaved([...saved]);
  }, []);

  return (
    <div>
      {props.pathName === "/" ? null : props.pathName ===
        "/sign-in" ? null : props.pathName === "/new-story" ? null : (
        <Header
          savedToList={savedToList}
          email={props.email}
          firstName={props.firstName}
          ownSaved={ownSaved}
        />
      )}

      <Routes>
        <Route
          path="bosh-sahifa"
          element={
            <BoshSahifa
              firstName={props.firstName}
              savedToList={savedToList}
              setSavedToList={setSavedToList}
              setNewList={setNewList}
              saved={saved}
              setSaved={setSaved}
              mainArr={mainArr}
              setMainArr={setMainArr}
              newList={newList}
            />
          }
        />
        <Route
          path="saqlangan"
          element={
            <Saqlangan
              saved={saved}
              newList={newList}
              setNewList={setNewList}
              savedToList={savedToList}
              inputVal={inputVal}
              setInputVal={setInputVal}
            />
          }
        />
        <Route
          path="saqlangan/reading-list-all"
          element={
            <ReadingListAll
              savedToList={savedToList}
              setSavedToList={setSavedToList}
            />
          }
        />

        <Route
          path="new-story"
          element={
            <NewStory
              setOwnSaved={setOwnSaved}
              ownSaved={ownSaved}
              mainArr={mainArr}
              setMainArr={setMainArr}
            />
          }
        />

        <Route
          path="bosh-sahifa/:id"
          element={
            <DescInside
              mainArr={mainArr}
              firstName={props.firstName}
              location={props.pathName}
            />
          }
        />
        <Route path="my-saved" element={<MySaved ownSaved={ownSaved} />} />
        <Route path="news" element={<News />} />
        <Route path="saqlangan/:id" element={<ListEach newList={newList} setNewList={setNewList} />} />
        <Route path="my-saved/:id" element={<EachSaved ownSaved={ownSaved} />}/>

      </Routes>
    </div>
  );
}
